import * as types from '../actionTypes';
import api from '../../Services/api';
import logger from '../../Services/logger';

/**
 * Thunks do Link de Pagamento — integrados à API real.
 *
 * Autenticados (agência, direito payBooking/payMultipleBookings; master → 403):
 *   create / list / resend / cancel / by-reservation  (POST /api/v1/payment-link/*)
 * Públicos (sem JWT, autorizados pelo token na URL):
 *   open / status  (GET /api/v1/public/payment-link/:token[/status])
 *
 * PAY (cobrança Cielo) ainda NÃO está pronto no backend — `payPaymentLink` é um
 * stub que avisa "em breve"; trocar pelo POST .../pay quando o endpoint existir.
 */

// ---- Autenticados (agência) ------------------------------------------------

export const retrievePaymentLinks = (params = {}) => async (dispatch) => {
	dispatch({ type: types.SET_PAYMENT_LINK_LOADING, payload: true });
	try {
		const data = await api.post('/api/v1/payment-link/list', params).then((r) => r.data);
		dispatch({ type: types.SET_PAYMENT_LINKS, payload: data.items || [] });
		return data;
	} catch (e) {
		logger.error('[PaymentLink.list]', e?.response?.data || e?.message);
		throw e;
	} finally {
		dispatch({ type: types.SET_PAYMENT_LINK_LOADING, payload: false });
	}
};

// Cria e (o backend) envia o link. Retorna o link criado.
export const createPaymentLink = (payload) => async () => {
	const data = await api.post('/api/v1/payment-link/create', payload).then((r) => r.data);
	return data.link;
};

// Links de uma reserva (com a timeline em PaymentLinkEvents).
export const retrieveLinksByReservation = (reservationId) => async () => {
	const data = await api.post('/api/v1/payment-link/by-reservation', { reservationId }).then((r) => r.data);
	return data.links || [];
};

// Reenvia o e-mail de um link existente (aceita token OU id).
export const resendPaymentLink = (tokenOrId) => async () => {
	const body = typeof tokenOrId === 'number' ? { id: tokenOrId } : { token: tokenOrId };
	await api.post('/api/v1/payment-link/resend', body).then((r) => r.data);
};

export const cancelPaymentLink = (id) => async () => {
	await api.post('/api/v1/payment-link/cancel', { id }).then((r) => r.data);
};

// ---- Públicos (página de pagamento, sem JWT) -------------------------------

// Abre o link (marca 'aberto', backend calcula o câmbio do momento).
export const openPaymentLink = (token) => async (dispatch) => {
	const data = await api.get(`/api/v1/public/payment-link/${token}`).then((r) => r.data);
	dispatch({ type: types.SET_SELECTED_PAYMENT_LINK, payload: data.link });
	return data.link;
};

// Re-checa o status (load/volta de aba).
export const checkPaymentLinkStatus = (token) => async () => {
	const data = await api.get(`/api/v1/public/payment-link/${token}/status`).then((r) => r.data);
	return data.status;
};

/**
 * Cobrança (Cielo). POST público .../pay. Resolve em 200 (pago) ou 202 (pendente);
 * rejeita em 402/403/409/400/5xx (o caller trata por code). Em 200, atualiza o
 * selectedLink para 'pago' (renderiza o comprovante). O backend é idempotente.
 * @param {object} payload { creditCard, installments, customer }
 */
export const payPaymentLink = (token, payload) => async (dispatch, getState) => {
	const data = await api.post(`/api/v1/public/payment-link/${token}/pay`, payload).then((r) => r.data);
	if (data && data.success && !data.pending) {
		const cur = getState().paymentLinkReducer?.selectedLink || {};
		dispatch({
			type: types.SET_SELECTED_PAYMENT_LINK,
			payload: {
				...cur,
				status: 'pago',
				pagoEm: new Date().toISOString(),
				// mesma forma do open público (transactionId/amount/currency/installments…)
				// p/ o comprovante ser idêntico ao reabrir o link.
				transacao: { ...(cur.transacao || {}), ...(data.transaction || {}) },
			},
		});
	}
	return data;
};
